import { BehaviorSubject } from 'rxjs';
import type { ActiveRecordRef } from '../components/active-record/active-record.component';

const activeRecordSubject = new BehaviorSubject<ActiveRecordRef | null>(null);

export function getActiveRecordReference() {
  return activeRecordSubject.asObservable();
}

export function setActiveRecordReference(reference: ActiveRecordRef | null) {
  activeRecordSubject.next(reference);
}
